<template>
  <div class="pb-2">
    <!-- <Search
        class="mb-75"
        :default-search-data="payloadSearch"
        :is-disable="loadingSearch"
        :is-class-booking="true"
        @handleSearch="globalSearchHandle"
      /> -->

    <BRow class="mb-1">
      <BCol class="px-50">
        <ClassBookingProSearch />
      </BCol>
    </BRow>

    <BRow>
      <BCol
        cols="12"
        md="7"
        class="px-50"
      >
        <ClassBookingProTrip />
      </BCol>

      <BCol
        cols="12"
        md="5"
        :class="`px-50 ${isMobileView ? 'mt-1' : ''}`"
      >
        <ClassBookingProBook />
      </BCol>
    </BRow>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
} from 'bootstrap-vue'
import {
  onBeforeMount, onUnmounted, ref,
  // onBeforeUpdate,
} from '@vue/composition-api'
import { isEmpty } from 'lodash-es'

import store from '@/store'
import router from '@/router'

import storeModule from '@flightv2/bookingStoreModule'

import useToast from '@useToast'

// import useToast from '@useToast'

import useClassBookingPro from './useClassBookingPro'

export default {
  components: {
    BRow,
    BCol,

    // Search: () => import('@flightv2/search/re-search/index.vue'),
    ClassBookingProSearch: () => import('./ClassBookingProSearch.vue'),
    ClassBookingProTrip: () => import('./ClassBookingProTrip.vue'),
    ClassBookingProBook: () => import('./ClassBookingProBook.vue'),
  },
  setup() {
    // onBeforeUpdate(() => {
    //   console.log("UPDATE'ClassBookingPro' ")
    // })
    const { toastError } = useToast()

    const {
      loadingSearch,
      reset,
      searchClassBooking,
      setQuantityPax,
    } = useClassBookingPro()

    const FLIGHT_APP_STORE_MODULE_NAME = 'app-flight-v2'
    if (!store.hasModule(FLIGHT_APP_STORE_MODULE_NAME)) {
      store.registerModule(FLIGHT_APP_STORE_MODULE_NAME, storeModule)
    }
    onUnmounted(() => {
      if (store.hasModule(FLIGHT_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(FLIGHT_APP_STORE_MODULE_NAME)
      }
      reset()
    })
    if (isEmpty(store.getters['app-flight-v2/getAirportGroup'])) {
      store.dispatch('app-flight-v2/fetchAirportGroup')
    }

    const payloadSearch = ref({ ...JSON.parse(localStorage.getItem('searchFlight')) }) // Common search

    function getLocalPayloadSearch() {
      return { ...JSON.parse(localStorage.getItem('searchFlight')) }
    }

    // function globalSearchHandle(payload) {
    //   const data = {
    //     req: payload,
    //     isGlobalSearch: true,
    //     isAddNewTab: false,
    //   }
    //   searchClassBooking(data)
    // }

    onBeforeMount(() => {
      console.log('onBeforeMount: ', payloadSearch.value)
      if (!localStorage.getItem('searchFlight')) {
        router.push({ name: 'apps-flightsV2-page' })
        return
      }

      if (!['VN1A'].includes(payloadSearch.value?.source)) {
        toastError({ title: 'Vui lòng chọn hãng VNA để tìm kiếm class booking !' })

        router.push({ name: 'apps-flightsV2-page' })
        return
      }

      const data = {
        req: getLocalPayloadSearch(),
        isGlobalSearch: true,
        isAddNewTab: false,
      }
      searchClassBooking(data)
      setQuantityPax(getLocalPayloadSearch())
    })

    return {
      loadingSearch,
      payloadSearch, // Common search

      // globalSearchHandle,
      searchClassBooking,
    }
  },
}
</script>

<style lang="scss">

</style>
